import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import Map from 'components/map/Map'
import MicromobilityLayer from 'components/map/MicromobilityLayer'
import ParkingLayer from 'components/map/ParkingLayer'
import StopLayer from 'components/map/StopLayer'
import Navbar from 'components/Navbar'
import BackButton from 'src/components/BackButton'
import NavigatorBubble from 'src/components/NavigatorBubble'
import TripVehicleLayer from 'src/components/map/TripVehicleLayer'
import { NavigatorProvider } from 'src/contexts/NavigatorContext'
import theme from 'src/theme'

const Root = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <NavigatorProvider>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ flex: 1 }} id="app-inner">
                        <BackButton />
                        <Map />
                        <StopLayer />
                        <ParkingLayer />
                        <MicromobilityLayer />
                        <TripVehicleLayer />
                    </div>
                    <Outlet />
                    <NavigatorBubble />
                    <Navbar />
                </div>
            </NavigatorProvider>
        </ThemeProvider>
    )
}

export const Route = createRootRoute({
    component: Root,
})
